import {Container, Row, Col} from 'react-bootstrap';
import {useLanguageContext, useThemeContext} from '../../../../context';
import withObservables from '@nozbe/with-observables';
import {DEVICE_HEIGHT} from '../../../../constants';
import {useSearch} from '../../../../hooks';
import PosAppModal from '../PosAppModal';
import SearchBox from '../../SearchBox';
import ListItem from './ListItem';
import NonIdealScreen from '../../NonIdeal';
import {observeActiveWaiters} from '../../../../pos-core/database/helpers/waiter';
import usePermission from '../../../../hooks/usePermission';

const SelectedWaiterModal = ({toggle, setToggle, waiters, handleSelect, handleCreateWaiter, order}) => {
    const {I18n} = useLanguageContext();
    const {theme} = useThemeContext();
    const userPermission = usePermission('waiters');

    const {text, setText, searchList} = useSearch(handleSearch);

    function handleClose(event) {
        setToggle(false);
    }

    const handleCreate = () => {
        handleCreateWaiter();
    };

    const onChange = (event, key) => {
        let value = key || event?.target?.value || '';
        setText(value);
    };

    function handleSearch(val) {
        return waiters.filter(x => x.name.toLowerCase().includes(val.toLowerCase()) || x.phone_number.toLowerCase().includes(val.toLowerCase()));
    }

    return (
        <PosAppModal
            className="selectCustomerModal"
            toggle={toggle}
            backCta={{
                name: 'backArrowIcon',
                fill: theme.barclaysBlue,
                width: '18',
                height: '18',
                viewBox: '0 0 18 18',
            }}
            handleClose={handleClose}
            rightCta={
                userPermission?.canCrud &&
                waiters?.length && {
                    title: I18n.create_waiter,
                    action: handleCreateWaiter,
                    iconName: 'add2Icon',
                    fill: theme.barclaysBlue,
                    width: '18',
                    height: '18',
                    viewBox: '0 0 18 18',
                }
            }
            title={'Add Waiter'}>
            <>
                {!waiters.length == 0 && (
                    <SearchBox
                        type="pos"
                        placeholder={I18n.search_customer_name_phone_or_email}
                        prefix={{
                            name: 'search2Icon',
                            fill: theme.white,
                        }}
                        onChange={onChange}
                    />
                )}

                <Container fluid>
                    <Row className="justify-content-md-center">
                        <Col md={12}>
                            {waiters.length ? (
                                <div
                                    className="selectCustomerListBox tableListMainBox"
                                    style={{
                                        height: DEVICE_HEIGHT - 150,
                                    }}>
                                    {(text ? searchList : waiters).map((val, index) => (
                                        <ListItem order={order} key={index} waiter={val} onPress={handleSelect} />
                                    ))}
                                </div>
                            ) : (
                                <NonIdealScreen
                                    heading={I18n.waiter}
                                    subHeading={I18n.create_new_waiter_and_add_to_sale}
                                    name="customerSquareIcon"
                                    fill={theme.white}
                                    primaryCta={
                                        userPermission?.canCrud
                                            ? {
                                                  title: I18n.create_waiter,
                                                  action: handleCreate,
                                              }
                                            : null
                                    }
                                    isMultiStep={false}
                                />
                            )}
                        </Col>
                    </Row>
                </Container>
            </>
        </PosAppModal>
    );
};

const enhance = withObservables([], () => ({
    waiters: observeActiveWaiters(),
}));

export default enhance(SelectedWaiterModal);
